"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const class_validator_1 = require("class-validator");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const authorization_service_1 = require("./authorization.service");
const permissions_1 = require("./permissions");
class CreateRoleDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", String)
], CreateRoleDto.prototype, "key", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(2),
    tslib_1.__metadata("design:type", String)
], CreateRoleDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CreateRoleDto.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    tslib_1.__metadata("design:type", Array)
], CreateRoleDto.prototype, "permissions", void 0);
class UpdateRoleDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(2),
    tslib_1.__metadata("design:type", String)
], UpdateRoleDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], UpdateRoleDto.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    tslib_1.__metadata("design:type", Array)
], UpdateRoleDto.prototype, "permissions", void 0);
let RolesController = class RolesController {
    constructor(authorizationService) {
        this.authorizationService = authorizationService;
    }
    roles() {
        return this.authorizationService.listRoles();
    }
    roleOptions() {
        return this.authorizationService.listRoleOptions();
    }
    permissions() {
        return this.authorizationService.listPermissionCatalog();
    }
    createRole(dto) {
        return this.authorizationService.createRole(dto);
    }
    updateRole(key, dto) {
        return this.authorizationService.updateRole(key, dto);
    }
};
exports.RolesController = RolesController;
tslib_1.__decorate([
    (0, common_1.Get)('roles'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.USERS_MANAGE),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], RolesController.prototype, "roles", null);
tslib_1.__decorate([
    (0, common_1.Get)('roles/options'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.USERS_MANAGE),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], RolesController.prototype, "roleOptions", null);
tslib_1.__decorate([
    (0, common_1.Get)('permissions'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.USERS_MANAGE),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], RolesController.prototype, "permissions", null);
tslib_1.__decorate([
    (0, common_1.Post)('roles'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.USERS_MANAGE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [CreateRoleDto]),
    tslib_1.__metadata("design:returntype", void 0)
], RolesController.prototype, "createRole", null);
tslib_1.__decorate([
    (0, common_1.Patch)('roles/:key'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.USERS_MANAGE),
    tslib_1.__param(0, (0, common_1.Param)('key')),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, UpdateRoleDto]),
    tslib_1.__metadata("design:returntype", void 0)
], RolesController.prototype, "updateRole", null);
exports.RolesController = RolesController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof authorization_service_1.AuthorizationService !== "undefined" && authorization_service_1.AuthorizationService) === "function" ? _a : Object])
], RolesController);
